import {theme} from "@chakra-ui/core";

export default {
  ...theme,
  colors: {
    ...theme.colors,
    primary: {
      ...theme.colors.green,
      8: "rgba(51, 164, 102, .1)",
      50: "#EBF5F0",
      100: "#EBF5F0",
      200: "#D4ECC4",
      300: "#62997E",
      400: "#62997E",
      500: "#22594B",
      600: "#22594B",
      700: "#22594B",
      800: "#22594B",
      900: "#162D27",
    },
    ordersStates: {
      100: "rgba(51, 164, 102, 0.08)",
      200: "#EBF8FF",
      300: "rgba(121, 28, 165, 0.08)",
      400: "#F6F7F8",
      500: "rgba(228, 88, 101, 0.08)",
    },
  },
};
